import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/media/icons/duotone/Media/Repeat.svg'


const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column align-items-end"
}
const _hoisted_4 = { class: "indicator-label svg-icon svg-icon-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Resend ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("section", null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.data?.data.webhook_outbounds.length >= 1)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_ctx.checkPermission('webhook-resend').isGranted)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    ref: "submitButton",
                    class: "btn btn-sm btn-info",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resend(_ctx.data?.data.webhook_outbounds[0].id)))
                  }, [
                    _createVNode("span", _hoisted_4, [
                      _createVNode(_component_inline_svg, { src: _imports_0 }),
                      _hoisted_5
                    ]),
                    _hoisted_6
                  ], 512))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data?.data.webhook_outbounds)
          ? (_openBlock(), _createBlock(_component_vue_json_pretty, {
              key: 1,
              data: _ctx.data?.data.webhook_outbounds,
              deep: 1
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_directive_loading, !_ctx.data]
    ])
  ]))
}